// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';

// Configure axios defaults
axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.xsrfCookieName = 'csrftoken';

export const loadCSRFToken = async () => {
    try {
        const response = await axios.get('/api/csrf/', {
            ...commonConfiguration,
            withCredentials: true,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });

        const csrfToken = response.data.csrfToken || document.cookie
            .split('; ')
            .find(row => row.startsWith('csrftoken='))
            ?.split('=')[1];

        if (csrfToken) {
            axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
            console.log('CSRF token loaded and configured');
        } else {
            console.warn('CSRF token not found in response or cookies');
        }
    } catch (error) {
        console.error('Failed to load CSRF token:', error);
        const csrfToken = document.cookie
            .split('; ')
            .find(row => row.startsWith('csrftoken='))
            ?.split('=')[1];
            
        if (csrfToken) {
            axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
            console.log('Using existing CSRF token from cookie');
        }
    }
};
